let config;
if (process.env && process.env.config_JSON_PATH) {
    const path = require('path');
    const jsonPath = process.env.config_JSON_PATH;
    const requirePath = path.join(process.cwd(), jsonPath);

    config = require(requirePath);
} else {
    config = require('config.json');
}
const transformer = require('./configJsonTransformer');

module.exports = {
    ...transformer(config)
};
